"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CdrCategory = void 0;
var CdrCategory;
(function (CdrCategory) {
    CdrCategory["UNKNOWN"] = "unknown";
    CdrCategory["TEST_EXTENSION"] = "test-extension";
    CdrCategory["INTERNAL_SIP"] = "internal-sip";
    CdrCategory["EAVESDROP"] = "eavesdrop";
    CdrCategory["VIDEO_CALL"] = "video-call";
    CdrCategory["TEST_VIDEO_CALL"] = "test-video-call";
    CdrCategory["AUDIO_CALL"] = "audio-call";
    CdrCategory["PHONETRACKER"] = "phonetracker";
    CdrCategory["VIDEO_VISITATION"] = "visitation";
    CdrCategory["AUDIO_VISITATION"] = "audio-visitation";
    CdrCategory["VOICEMAIL"] = "voicemail";
    CdrCategory["SUPPORT_REQUEST"] = "support-request";
    CdrCategory["INFO_CENTER"] = "info-center";
    CdrCategory["TEXT"] = "text";
    CdrCategory["TTY"] = "tty";
    CdrCategory["COMMISSARY"] = "commissary";
})(CdrCategory = exports.CdrCategory || (exports.CdrCategory = {}));
